import { render, staticRenderFns } from "./CollectorOrderInsert.vue?vue&type=template&id=18ffc3c4&scoped=true&"
import script from "./CollectorOrderInsert.vue?vue&type=script&lang=js&"
export * from "./CollectorOrderInsert.vue?vue&type=script&lang=js&"
import style0 from "./CollectorOrderInsert.vue?vue&type=style&index=0&id=18ffc3c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ffc3c4",
  null
  
)

export default component.exports